import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { handleResponse } from '../../MainModule/common/handleResponse';
import { IErvkCheckList } from '../../DictionariesModule/interfaces/IErvkCheckList';

export async function fetchErvkCheckList(
  controlKindId: string,
  knmKindId: string,
  subjectKindIds?: string[],
): Promise<IErvkCheckList[]> {
  let subjectKindIdsString = '';

  if (subjectKindIds) {
    subjectKindIdsString = subjectKindIds.filter(i => i !== '').join(',');
  }
  const url = `/erknm-catalogs/api/dictionaries/ervk-check-list?controlKindId=${controlKindId}&knmKindId=${knmKindId}${
    subjectKindIdsString ? `&subjectKindIds=${subjectKindIdsString}` : ''
  }`;
  const mockData = apiMockSwitcher<IErvkCheckList[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
